import Vue from 'vue';
import Vuex from 'vuex';
import customer from './modules/customer';
import pageTexts from './modules/page-texts';
import services from './modules/services';
import dns from './modules/dns';
import user from './modules/user';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        customer,
        pageTexts,
        user,
        services,
        dns
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        })
    ]
});
